import {DrillHoleConfiguration} from "@/Models/DrillHoleConfigurations/DrillHoleConfiguration";
import RadialDrillHoleConfiguration from "@/Models/DrillHoleConfigurations/RadialDrillHoleConfiguration";
import GridDrillHoleConfiguration from "@/Models/DrillHoleConfigurations/GridDrillHoleConfiguration";
import EdgeDrillHoleConfiguration from "@/Models/DrillHoleConfigurations/EdgeDrillHoleConfiguration";
import NullDrillHoleConfiguration from "@/Models/DrillHoleConfigurations/NullDrillHoleConfiguration";

export default class DrillHoleConfigurationFactory {
	get_configuration( drillHoleType: string ): DrillHoleConfiguration {
		switch( drillHoleType ) {
			case 'radial':
				return new RadialDrillHoleConfiguration();
			case 'grid':
				return new GridDrillHoleConfiguration();
			case 'edge':
				return new EdgeDrillHoleConfiguration();
			default:
				return new NullDrillHoleConfiguration();
		}
	}
}
